import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { User } from '@/types'
import { api, setAccessToken } from '@/services/api'

export const useSessionStore = defineStore('session', () => {
  const user = ref<User | null>(null)
  const locale = ref('zh-CN')
  const authenticated = computed(() => user.value !== null)

  async function restore() {
    try {
      user.value = (await api<{ user: User }>('/me')).user
      const settings = await api<{ language: string }>('/me/language')
      locale.value = settings.language || 'zh-CN'
    } catch { setAccessToken(''); user.value = null }
  }
  async function login(username: string, password: string) {
    const result = await api<{ token: string; user: User }>('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) })
    setAccessToken(result.token); user.value = result.user
    const settings = await api<{ language: string }>('/me/language')
    locale.value = settings.language || 'zh-CN'
  }
  async function setLocale(value: string) { locale.value = value; await api('/me/language', { method: 'PUT', body: JSON.stringify({ language: value }) }) }
  function logout() { setAccessToken(''); user.value = null }
  return { user, locale, authenticated, restore, login, setLocale, logout }
})
